'use strict';
/**
 * Created by Joey Hardy on 7/6/2015.
 */
searchModule.controller('SearchController', ['$scope', '$rootScope', 'productComboSearchService',
    'SearchFilters', 'erateSessionVarsService', 'welcomeEvents', '$location', 'routes',
    'quoteIntegrationService', 'quoteIntegrationConstants','TLCError','AppErrorCodes', '$window',
    function ($scope, $rootScope, productComboSearchService,
              SearchFilters, erateSessionVarsService, welcomeEvents, $location, routes,
              quoteIntegrationService, quoteIntegrationConstants, TLCError,AppErrorCodes, $window) {

        //$scope.results = [];

        // UNKNOWN (below) means we have no search results, either because we haven't done a search yet or the last search errored
        // Note that a search which returns an empty result is NOT an error. 
        var SearchStatuses = {SEARCHING: 0, SUCCESS: 1, UNKNOWN: 2};
        $scope.searchQuery = '';
        $scope.previousQuery = '';

        $scope.searchStatus = SearchStatuses.UNKNOWN;  // No search performed yet
        $scope.comboSearchDone = false;
        $scope.dmsSearchDone = false;
        $scope.menuSearchDone = false;
        $scope.results = productComboSearchService.results;
        $scope.mastheadShowSearch = true;

        var typePriorityValues = [];
        typePriorityValues[productComboSearchService.searchResultTypes.combo] = 3;
        typePriorityValues[productComboSearchService.searchResultTypes.menu] = 2;
        typePriorityValues[productComboSearchService.searchResultTypes.dms] = 1;

        //When the Welcome Screen starts a Search, we listen the event and proceed with the search
        $scope.$on(welcomeEvents.welcomeFindTransaction, function(event, searchQuery) {
            $scope.searchQuery = searchQuery;
            $scope.search();
        });

        $scope.search = function() {
            productComboSearchService.clearResults();
            $scope.previousQuery = $scope.searchQuery;
            doSearch();
        };

        $scope.searching = function() {
            return $scope.searchStatus === SearchStatuses.SEARCHING;
        }

        $scope.hideEmptyResultMessage = function() {
            return $scope.searchStatus !== SearchStatuses.SUCCESS || $scope.results.list.length > 0;
        }


        $scope.goPreviousView = function(){
            $window.history.back();
        };

        $scope.showVehicle = function(searchItem) {
            var vin = searchItem.vehicle.vin;
            var details = searchItem.vehicleDetails;
            if (details.length < 6)
                details = "";
            return details + (details.length > 0 ? " -- " : "") + (vin.length > 3 ? "VIN: " + vin : "");
        };

        $scope.showSource = function(type) {
            // This is a temporary function, to show source of a search item based on its priority.  This will not be displayed in final version.
            var resultTypes = productComboSearchService.searchResultTypes;
            switch (type) {
                case resultTypes.combo: return "ERating";
                case resultTypes.menu: return "Menu";
                case resultTypes.dms: return "DMS";
                default: return "";
            }
        };

        function doSearch() {
            if($scope.searchStatus === SearchStatuses.SEARCHING)
                return;

            $scope.searchStatus = SearchStatuses.SEARCHING;

            var params = createParameters($scope.searchQuery ? $scope.searchQuery : '');
            productComboSearchService.search(params)
                .then(function (successTable) {
                    $scope.searchStatus = SearchStatuses.SUCCESS;
                }, function (errorMsg) {
                    $scope.searchStatus = SearchStatuses.UNKNOWN;
                    throw new TLCError(new Error(errorMsg),AppErrorCodes.SearchController_GeneralError);
                }, function (update) {
                    switch (update.type) {
                        case productComboSearchService.searchResultTypes.combo:
                        {
                            $scope.comboSearchDone = true;
                            break;
                        }
                        case productComboSearchService.searchResultTypes.dms:
                        {
                            $scope.dmsSearchDone = true;
                            break;
                        }
                        case productComboSearchService.searchResultTypes.menu:
                        {
                            $scope.menuSearchDone = true;
                            break;
                        }
                    }
                });
        }

        $scope.goToQuote = function(searchResult) {
            switch(searchResult.searchType) {
                case productComboSearchService.searchResultTypes.alternateCombo:
                case productComboSearchService.searchResultTypes.combo: {
                    if(searchResult.quoteSessionId) {
                        $location.path(routes.createQuote).search('qsession', searchResult.quoteSessionId);
                    }
                    break;
                }
                case productComboSearchService.searchResultTypes.menu:
                case productComboSearchService.searchResultTypes.dms: {
                    var integrationData = {
                        dateOfSale: searchResult.vehicle.dateOfSale,
                        vehicleInfo: searchResult.vehicle
                    };

                    angular.extend(integrationData, searchResult);
                    quoteIntegrationService.captureIntegrationData(integrationData);
                    erateSessionVarsService.setQuotingMode(quoteIntegrationConstants.searchIntegrated);
                    $location.path(routes.createQuote).search('src', 'search');
                    break;
                }
            }
        };

        function createParameters(query, pageNum, pageSize, sortBy, sortOrder) {
            var paramObj = {
                dealerId : erateSessionVarsService.getCurrentDealerSPANId(),

                paging : {
                    num : pageNum || 1,
                    size : pageSize || 25,
                    sortBy : sortBy || 'quoteDate',
                    sortOrder : sortOrder || 'desc'
                },
                filters : new SearchFilters()
            };

            paramObj.filters.businessName = query;
            if(query.isVin()) {
                paramObj.filters.vin = query;
            } else if(query.match(/^[\d]*$/) && !productComboSearchService.suppressDmsSearch && !productComboSearchService.suppressMenuSearch) { // does the query contain numbers (but isn't a vin)
                paramObj.dealNumber = query;
                //paramObj.stockNumber = query;
            } else {
                // try a few different formats:
                //  - lastName, firstName
                //  - firstName lastName
                //  - lastName
                var reverseOrderNames = query.split(', ');
                if(reverseOrderNames.length > 1) {
                    paramObj.filters.lastName = reverseOrderNames[0];
                    paramObj.filters.firstName = reverseOrderNames[1];
                } else {
                    var names = query.split(' ');
                    if(names.length > 1) {
                        paramObj.filters.firstName = names[0];
                        paramObj.filters.lastName = names[1];
                    } else {
                        paramObj.filters.lastName = query;
                    }
                }
            }

            return paramObj;
        }

    }
]);